import { Component, Inject,OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { SeverityViewService } from '../services/severity-view.service';
import { LoadingService } from '../services/loading.service';
import { finalize } from 'rxjs/operators';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { NgFor, NgIf } from '@angular/common';
import { MatFormField, MatLabel } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-acknowledge-table',
    templateUrl: './acknowledge-table.component.html',
    styleUrls: ['./acknowledge-table.component.scss'],
    imports: [CdkScrollable, MatDialogContent, MatTable, MatSort, NgFor, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, NgIf, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton]
})
export class AcknowledgeTable {
  commentformgroup: FormGroup<{
    formcomment: FormControl<string | null>;
  }>;
  
  Resultid: string;
  AcknowledgeDataSource: any[];
  displayedColumns = [];
  commententered :string;
  userName:string
  userNameStatus =false;
  sessionActive$: Subscription;
  Site: string;
  acknowledgeresultid :string;
  hasExistingComment: boolean = false;
  isEditMode: boolean = false;
  existingComment: string = '';
  
  constructor(public dialogRef: MatDialogRef<AcknowledgeTable>,
    @Inject(MAT_DIALOG_DATA) public AcknowledgeData: AcknowledgeDialogData,    
    private commentFormBuilder: FormBuilder,private cognito: GeaMesCognitoAuthService,
    private service: SeverityViewService,
    private loadingService: LoadingService
  )
  
  { 
    console.info(AcknowledgeData)
    this.AcknowledgeDataSource = AcknowledgeData.acknowledge
    this.Resultid = AcknowledgeData.resultid
    this.Site = AcknowledgeData.site
    this.acknowledgeresultid = AcknowledgeData.acknowlegderesultid

    if (this.AcknowledgeDataSource && this.AcknowledgeDataSource.length > 0) {
      const comment = this.AcknowledgeDataSource[0]?.Comment;

      if (comment) {
        this.hasExistingComment = true;
        this.existingComment = comment;
        this.isEditMode = false;
      } else {
        this.hasExistingComment = false;
        this.isEditMode = true;
      }
    }

    if(this.AcknowledgeDataSource[0] !=null)
    {
      this.displayedColumns = Object.keys(this.AcknowledgeDataSource[0])
    }
    else
    {
      this.displayedColumns.push ("Comment",
      "Insert Datetime",
      "Update Datetime",
      "User ID")
    }


    
    this.commentformgroup = this.commentFormBuilder.group({
      formcomment: ['', [Validators.required]]
    })
    
    this.commentformgroup.valueChanges.subscribe((formValues) =>{
      this.commententered = formValues.formcomment
    });
  
    this.sessionActive$ = this.cognito.sessionEstablished$.subscribe(x => {
      this.userName= this.cognito.getUserAttribute('sso')
      if(this.userName!=''){
        this.userNameStatus=true;
      }
      if(this.sessionActive$){
        this.sessionActive$.unsubscribe();}
   });

  }
  
  enableEdit() {
    this.isEditMode = true;
    this.commentformgroup.patchValue({
      formcomment: this.existingComment
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
  close(): void {
    this.dialogRef.close();
  }

  saveacknowledgedetails():void {

    if (this.commentformgroup.status == 'VALID'){
 this.loadingService.show();
      
      console.log(this.commententered)
      console.log (this.Resultid)
      console.log(this.userName)
      console.log(this.Site)
      this.service.updateAcknowledgementDetails(this.Site,this.Resultid,this.commententered,this.userName,this.acknowledgeresultid)
      .pipe(finalize(() => this.loadingService.hide())).subscribe(); 
      setTimeout(() => {
        this.dialogRef.close()
    }, 3000);

      
    } else {
      console.error('Invalid pitchFormGroup, was not caught in form control error handling.')
    }
  }

  

}

export interface AcknowledgeDialogData {
  acknowledge: any[];
  resultid:string;
  site:string;
  acknowlegderesultid :string;
}
